import { useState } from "react";

import ApiRequestErrorHandler from "../../../global/ApiRequestErrorHandler";
import { validateContactInfo, validateEmail, validateName, validatePhone } from "../config/helper";
import { STRINGS } from "../utils/string";

export default function useContactsHandlers({ id, contactRepository, revalidate }) {
  const [mode, setMode] = useState(null);
  const [modalSize, setModalSize] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [additionalDetails, setAdditionalDetails] = useState({});

  const handleFailure = () => {
    setShowFailureModal(false);
    setAdditionalDetails((prev) => {
      const { ...rest } = prev;
      return rest;
    });
  };

  const openFailureModal = (error) => {
    setAdditionalDetails((prev) => ({
      ...prev,
      error: ApiRequestErrorHandler(error),
      handleFailure: () => handleFailure(),
    }));
    setShowFailureModal(true);
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const openAddModal = (relationType) => {
    setShowFailureModal(false);
    setAdditionalDetails({
      relationType: {
        key: relationType.key,
        value: relationType.value,
      },
      handleAdd: handleAdd,
      handleCancel: handleModalCancel,
    });
    setMode(STRINGS.MODAL_MODE.ADD);
    setModalSize(STRINGS.MODAL_SIZE.MEDIUM);
    handleOpenModal();
  };

  const openEditModal = (data) => {
    setShowFailureModal(false);
    setAdditionalDetails({
      data,
      handleEdit: handleEdit,
      handleCancel: handleModalCancel,
    });
    setMode(STRINGS.MODAL_MODE.EDIT);
    setModalSize(STRINGS.MODAL_SIZE.MEDIUM);
    handleOpenModal();
  };

  const openDeleteModal = (id) => {
    setShowFailureModal(false);
    setAdditionalDetails({
      id,
      handleDelete: () => handleDelete(id),
      handleCancel: handleModalCancel,
    });
    setMode(STRINGS.MODAL_MODE.DELETE);
    setModalSize(STRINGS.MODAL_SIZE.X_SMALL);
    handleOpenModal();
  };

  const openSuccessModal = () => {
    setShowFailureModal(false);
    setAdditionalDetails({
      handleSuccess: handleSuccess,
    });
    setMode(STRINGS.MODAL_MODE.SUCCESS);
    setModalSize(STRINGS.MODAL_SIZE.X_SMALL);
    handleOpenModal();
  };

  const handleModalCancel = () => {
    setAdditionalDetails({});
    handleCloseModal();
  };

  const validateBeforePost = (data) => {
    const { name, email, phone } = data;
    validateName(name);
    validateContactInfo(email, phone);
    validateEmail(email);
    validatePhone(phone);
  };

  const handleAdd = async (data) => {
    try {
      validateBeforePost(data);
      await contactRepository.createRecord(id, data);
      openSuccessModal();
    } catch (error) {
      openFailureModal(error);
    }
  };

  const handleEdit = async (data) => {
    try {
      await contactRepository.patch(id, data);
      openSuccessModal();
    } catch (error) {
      openFailureModal(error);
    }
  };

  const handleDelete = async (contactId) => {
    try {
      await contactRepository.delete(id, contactId);
      openSuccessModal();
    } catch (error) {
      openFailureModal(error);
    }
  };

  const handleSuccess = () => {
    handleCloseModal();
    revalidate();
  };

  return {
    mode,
    modalSize,
    openModal,
    showFailureModal,
    additionalDetails,
    handleCloseModal,
    handleFailure,
    openAddModal,
    openEditModal,
    openDeleteModal,
    openSuccessModal,
  };
}
